export default "__VITE_ASSET__wJu94HW___"